export const modifiableEnvironmentVariableFields = [
  "value",
  "is_json",
  "is_sensitive",
  "is_inheritable",
  "is_enabled",
  "visible_build",
  "visible_runtime",
  "application_scope"
] as const;

export const creatableEnvironmentVariableFields = [
  "name",
  "value",
  "is_json",
  "is_sensitive",
  "is_inheritable",
  "is_enabled",
  "visible_build",
  "visible_runtime",
  "application_scope"
] as const;
